import {createAction, props} from '@ngrx/store'
import {ExpensePaymentStatusAPIModel} from 'src/models/api.model'

const prefix = '[payment]'

export const UPDATE_EXPENSE_PAYMENTS_STATUS = createAction(
  `${prefix} update_expense_payments_status`,
  props<{
    status: string
    id: string
    paymentType: string
    statusUpdateInfo: string
    actionToCallAfterSuccess?: Function
  }>()
)

export const FETCH_EXPENSE_PAYMENTS_HISTORY = createAction(
  `${prefix} expense_payments_history`,
  props<{ id: string, paymentType: string }>()
)

export const FETCH_EXPENSE_PAYMENTS_HISTORY_SUCCESS = createAction(
  `${prefix} expense_payments_history_success`,
  props<{ expensePaymentHistory: ExpensePaymentStatusAPIModel[] }>()
)

export const UPDATE_REJECTION_TYPE = createAction(
  `${prefix} update_rejection_type`,
  props<{
    id: string
    rejectionType: string
  }>()
)

export const CLEAR_EXPENSE_PAYMENTS_HISTORY = createAction(`${prefix} clear_expense_payments_history`)
